<!--
 * @Author: 陈乾
 * @Date: 2025-09-19 10:21:40
 * @LastEditors: 陈乾
 * @LastEditTime: 2025-09-19 14:21:22
 * @Description: file content
 * @FilePath: /Cheers 上线速览/src/components/toggleCollapse.vue
-->
<template>
  <div class="toggleCollapse flex-x-y" @click="toggle">
    <p class="font14 toggleCollapse-text">
      {{ value ? collapseText : expandText }}
    </p>
    <van-icon :name="value ? 'arrow-up' : 'arrow-down'" size="12" color="#676870" />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    expandText: {
      type: String,
      default: ''
    },
    collapseText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  methods: {
    toggle() {
      this.$emit('input', !this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.toggleCollapse {
  width: 100%;
  padding: 12px 0;
  .toggleCollapse-text {
    margin-right: 4px;
    color: #676870;
  }
}
</style>
